import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { Button } from '../../Button/Button.tsx';

const ARROW_BUTTON_SIZE = 32;
// Icon-only child of Button (not a start/end icon slot), so it needs an explicit size; 24px matches the MUI default it replaces.
const ARROW_ICON_SIZE = 24;

type ArrowButtonProps = {
  dataTest?: string;
  disabled?: boolean;
  Icon: PhosphorIcon;
  onTransfer: () => void;
  tooltipText: string;
};

export const ArrowButton = ({ dataTest, disabled, Icon, onTransfer, tooltipText }: ArrowButtonProps) => (
  <Tooltip title={tooltipText}>
    <Box>
      <Button
        data-test={dataTest}
        disabled={disabled}
        onClick={onTransfer}
        sx={{
          height: `${ARROW_BUTTON_SIZE}px`,
          maxWidth: `${ARROW_BUTTON_SIZE}px`,
          minWidth: `${ARROW_BUTTON_SIZE}px`,
        }}
      >
        <Icon size={ARROW_ICON_SIZE} />
      </Button>
    </Box>
  </Tooltip>
);
